import { useEffect } from 'react';

const isObjectURL = (url: string) => url.startsWith('blob:');

function useRevokeObjectURL(url: string) {
  useEffect(() => {
    return () => {
      if (isObjectURL(url)) {
        URL.revokeObjectURL(url);
      }
    };
  }, [url]);
}

export default useRevokeObjectURL;
